import proxy from "api/proxy";
import { isHexColor } from "./colors";
import {
  COLOR_FIELDS,
  HOTEL_CONFIG_MODEL,
  HOTEL_DEFAULT_FIELDS,
  HOTEL_TIME_FIELDS,
  MELHOUS_MODEL,
  SITE_DEFAULT_COLORS,
  SITE_FIELDS,
} from "../constants";

function isFilled(value) {
  return value !== null && value !== undefined && String(value).trim() !== "";
}

async function fetchHotelConfig() {
  try {
    const { data, error } = await proxy.search(
      HOTEL_CONFIG_MODEL,
      [],
      Object.values(HOTEL_DEFAULT_FIELDS),
      1,
    );
    if (error || !data?.length) return null;
    return data[0];
  } catch {
    return null;
  }
}

function getHotelDefaults(config) {
  const defaults = {};
  if (!config) return defaults;
  Object.entries(HOTEL_DEFAULT_FIELDS).forEach(([field, hotelField]) => {
    const value = config[hotelField];
    if (!isFilled(value)) return;
    if (COLOR_FIELDS.includes(field) && !isHexColor(value)) return;
    defaults[field] = value;
  });
  return defaults;
}

function resolveHotelData(melhous, defaults) {
  const data = { ...defaults };
  Object.entries(melhous || {}).forEach(([field, value]) => {
    if (isFilled(value)) data[field] = value;
  });
  return data;
}

function getSiteColors(data) {
  return Object.fromEntries(
    COLOR_FIELDS.map((field) => [
      field,
      isHexColor(data[field]) ? data[field].trim() : SITE_DEFAULT_COLORS[field],
    ]),
  );
}

function getInheritedFields(melhous, defaults) {
  return Object.keys(defaults)
    .filter((field) => !isFilled(melhous?.[field]))
    .map((field) => ({ name: field, value: defaults[field] }));
}

function formatInheritedValue(name, value) {
  if (HOTEL_TIME_FIELDS.includes(name)) return String(value).slice(0, 5);
  return String(value);
}

async function fetchMelhous(fields = SITE_FIELDS) {
  const { data } = await proxy.search(MELHOUS_MODEL, [], fields, 1);
  return data?.[0] || null;
}

async function fetchSiteData(fields) {
  const [melhous, config] = await Promise.all([
    fetchMelhous(fields),
    fetchHotelConfig(),
  ]);
  return { melhous, defaults: getHotelDefaults(config) };
}

export {
  fetchHotelConfig,
  fetchMelhous,
  fetchSiteData,
  formatInheritedValue,
  getHotelDefaults,
  getInheritedFields,
  getSiteColors,
  isFilled,
  resolveHotelData,
};
